import { axiosInstance } from './base'

export function fetchPaymentMethods () {
  return axiosInstance.get('payment-methods/')
}

export function addPaymentMethod (data) {
  return axiosInstance.post('payment-methods/', data)
}

export function deletePaymentMethod (id) {
  return axiosInstance.delete(`payment-methods/${id}`)
}

export function setDefaultPaymentMethod (id) {
  return axiosInstance.put(`payment-methods/${id}/default`)
}

export function addRfpsPayment (data) {
  return axiosInstance.post('rfps-payment/', data)
}
